/** @format */

import { combineReducers } from "@reduxjs/toolkit";
import locale from "./reducer";

const reducer = locale;

export * from "./reducer";
export default reducer;
